import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsFooter} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

export function SelectableMaterialsDetailFooter() {
  const navigate = useNavigate();

  return (
    <SettingsFooter
      actions={[
        {
          type: 'button',
          variant: 'secondary',
          title: i18n.t('general.actions.close'),
          onClick: () => navigate(settingsRoutes.workshopSelectableMaterials),
        },
      ]}
    />
  );
}
